import { Container } from '@cgs/wge';
import { CheatManager, CheatManagerToken } from '../cheat-manager';
import { CheatPopupElementToken } from './cheat-popup';
import { CheatUISection } from './cheat-ui-section';
import { getCheatUIStyles } from './styles';

export const CheatFastSpinToken = Symbol('CheatFastSpin');

const FAST_SPIN_STORAGE_KEY = 'cheat_panel_fastSpinMode';

export class CheatFastSpinUI extends CheatUISection {
  constructor(private container: Container) {
    super();

    const cheatFastSpin = this.container.resolve<string[]>(CheatFastSpinToken);

    if (!cheatFastSpin) {
      return;
    }

    const fastSpinMode = localStorage.getItem(FAST_SPIN_STORAGE_KEY) === 'true';

    this.container.resolve<CheatManager>(CheatManagerToken).setFastSpinMode(fastSpinMode);

    this.initialize();
  }

  public initialize(): void {
    const consoleEl = this.container.resolve<HTMLDivElement>(CheatPopupElementToken);
    this.initializeBaseUI(consoleEl);
    this.setupConfigsUI();
    this.setupConfigsEventListeners();
  }

  private setupConfigsUI(): void {
    const fastSpinMode = this.container.resolve<CheatManager>(CheatManagerToken).getFastSpinMode();

    const styles = getCheatUIStyles();
    const content = `<div style="${styles.sectionStyle}">
       <label style="color:#fff;font-size:12px;cursor:pointer;display:flex;align-items:center;gap:4px;">
          Fast spin
          <input type="checkbox" id="fastSpinMode" ${fastSpinMode ? 'checked' : ''}>
        </label>
      </div>`;

    this.contentEl.innerHTML = content;
  }

  private setupConfigsEventListeners(): void {
    this.getChildEl('#fastSpinMode')?.addEventListener('change', () => {
      const fastSpinMode = this.getChildEl<HTMLInputElement>('#fastSpinMode')?.checked;

      localStorage.setItem(FAST_SPIN_STORAGE_KEY, JSON.stringify(!!fastSpinMode));

      this.container.resolve<CheatManager>(CheatManagerToken).setFastSpinMode(!!fastSpinMode);
    });
  }
}
